import React, { Component } from 'react';
import SsoLoginForm from "./ssoLoginForm";

export default class SsoLoginForms extends Component {
    
    render() {
        
        if(this.props.authenticationProviders === undefined) {
            
            return null;    
        }

        return (
            this.props.authenticationProviders
                .map((p, index) => {
                    return (
                        <SsoLoginForm provider={p} key={index} returnUrl={this.props.returnUrl} />
                    )
                }
            )
        );
    }
}